import { render, staticRenderFns } from "./ReductionReport.vue?vue&type=template&id=760d530e"
import script from "./ReductionReport.vue?vue&type=script&lang=js"
export * from "./ReductionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports